export default [
  {
    path: '/admin/apply/order/list',
    name: 'orderList',
    component: () => import('@/views/apply/order/list'),
    meta: {
      title: '订单列表',
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/order/detail',
    name: 'orderDetail',
    component: () => import('@/views/apply/order/detail'),
    meta: {
      title: '订单详情',
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/order/afterSale/list',
    name: 'afterSaleList',
    component: () => import('@/views/apply/order/afterSale/list'),
    meta: {
      title: '售后订单列表',
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/order/afterSale/detail',
    name: 'afterSaleDetail',
    component: () => import('@/views/apply/order/afterSale/detail'),
    meta: {
      title: '售后订单详情',
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/order/comment',
    name: 'commentManagement',
    component: () => import('@/views/apply/order/comment/index'),
    meta: {
      title: '评论管理',
      headType: 0,
      auth: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/apply/order.js